import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ENVIRONMENT, Environment } from '@cfp/core';
import { LoginPage } from '@cfp/features/authentication';
import { LoginFooter } from '@cfp/shared/ui/login';

@Component({
  selector: 'cfp-lbg-landing-page',
  templateUrl: './lbg-landing-page.html',
  styleUrls: ['./lbg-landing-page.scss'],
  imports: [LoginPage, LoginFooter],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LbgLandingPage {
  environment = inject<Environment>(ENVIRONMENT);
}
